module.exports = __webpack_public_path__ + "img/avatar1.73f14643.png";